/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rental_Booking_Status_Checked_InInputs */

const en_rental_booking_status_checked_in = /** @type {(inputs: Rental_Booking_Status_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Checked In`)
};

const es_rental_booking_status_checked_in = /** @type {(inputs: Rental_Booking_Status_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check-In Realizado`)
};

const fr_rental_booking_status_checked_in = /** @type {(inputs: Rental_Booking_Status_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arrivé`)
};

const de_rental_booking_status_checked_in = /** @type {(inputs: Rental_Booking_Status_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingecheckt`)
};

const id_rental_booking_status_checked_in = /** @type {(inputs: Rental_Booking_Status_Checked_InInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sudah Check-In`)
};

/** @type {(inputs: Rental_Booking_Status_Checked_InInputs) => LocalizedString} */
const ja_rental_booking_status_checked_in = en_rental_booking_status_checked_in;

/** @type {(inputs: Rental_Booking_Status_Checked_InInputs) => LocalizedString} */
const zh_rental_booking_status_checked_in = en_rental_booking_status_checked_in;

/** @type {(inputs: Rental_Booking_Status_Checked_InInputs) => LocalizedString} */
const ar_rental_booking_status_checked_in = en_rental_booking_status_checked_in;

/** @type {(inputs: Rental_Booking_Status_Checked_InInputs) => LocalizedString} */
const it_rental_booking_status_checked_in = en_rental_booking_status_checked_in;

/** @type {(inputs: Rental_Booking_Status_Checked_InInputs) => LocalizedString} */
const ru_rental_booking_status_checked_in = en_rental_booking_status_checked_in;

/** @type {(inputs: Rental_Booking_Status_Checked_InInputs) => LocalizedString} */
const pt_rental_booking_status_checked_in = en_rental_booking_status_checked_in;

/** @type {(inputs: Rental_Booking_Status_Checked_InInputs) => LocalizedString} */
const ko_rental_booking_status_checked_in = en_rental_booking_status_checked_in;

/**
* | output |
* | --- |
* | "Checked In" |
*
* @param {Rental_Booking_Status_Checked_InInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const rental_booking_status_checked_in = /** @type {((inputs?: Rental_Booking_Status_Checked_InInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rental_Booking_Status_Checked_InInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_rental_booking_status_checked_in(inputs)
	if (locale === "es") return es_rental_booking_status_checked_in(inputs)
	if (locale === "fr") return fr_rental_booking_status_checked_in(inputs)
	if (locale === "de") return de_rental_booking_status_checked_in(inputs)
	if (locale === "ja") return ja_rental_booking_status_checked_in(inputs)
	if (locale === "zh") return zh_rental_booking_status_checked_in(inputs)
	if (locale === "ar") return ar_rental_booking_status_checked_in(inputs)
	if (locale === "id") return id_rental_booking_status_checked_in(inputs)
	if (locale === "it") return it_rental_booking_status_checked_in(inputs)
	if (locale === "ru") return ru_rental_booking_status_checked_in(inputs)
	if (locale === "pt") return pt_rental_booking_status_checked_in(inputs)
	return ko_rental_booking_status_checked_in(inputs)
});